const pvtPaths = new Set(["/admin/update/profile", "/account-settings", "/employee-status"]);

export const isPrivateRoute = (href) =>
    pvtPaths.has(href);
